import { createRouter, createWebHistory } from "vue-router";
import store from "@/store/index";
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import PopupLayout from '@/layouts/PopupLayout.vue';

const BOARD_ADMIN_TYPE = "BOARD_ADMIN";
const NORMAL_TYPE = "NORMAL";

const routes = [
  //이하 (header + footer)
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: "/",
        name: "Main",
        component: () => import("@/views/Main.vue"),
      },
      {
        path: "/index.do",
        name: "Index",
        component: () => import("@/views/Main.vue"),
      },
      {
        path: "/main/loginPrev.do",
        name: "LoginPrev",
        component: () => import("@/views/Main.vue"),
      },
      {
        path: "/loginSSO.do",
        name: "IndexSSO",
        props: (route) => ({ from: route.query.from, ssoKey: route.query.sso_key }),
        component: () => import("@/views/LoginSSO.vue"),
      },
      {
        path: "/loginForm.do",
        name: "LoginForm",
        component: () => import("@/views/LoginForm.vue"),
      },
      {
        path: "/info/information.do",
        name: "ServiceInformation",
        component: () => import("@/views/info/ServiceInformation01.vue"),
        props: () => ({ type: 'info1' }),
      },
      {
        path: "/info/information1.do",
        name: "ServiceInformation01",
        component: () => import("@/views/info/ServiceInformation01.vue"),
        props: () => ({ type: 'info1' }),
      },
      {
        path: "/info/information2.do",
        name: "ServiceInformation02",
        component: () => import("@/views/info/ServiceInformation02.vue"),
        props: () => ({ type: 'info2' }),
      },
      {
        path: "/info/information3.do",
        name: "ServiceInformation03",
        component: () => import("@/views/info/ServiceInformation03.vue"),
        props: () => ({ type: 'info3' }),
      },
      {
        path: "/info/information4.do",
        name: "ServiceInformation04",
        component: () => import("@/views/info/ServiceInformation04.vue"),
        props: () => ({ type: 'info4' }),
      },
      {
        path: "/info/information5.do",
        name: "ServiceInformation05",
        component: () => import("@/views/info/ServiceInformation05.vue"),
        props: () => ({ type: 'info5' }),
      },
      {
        path: "/info/information6.do",
        name: "ServiceInformation06",
        component: () => import("@/views/info/ServiceInformation06.vue"),
        props: () => ({ type: 'info6' }),
      },
      {
        path: "/info/information7.do",
        name: "ServiceInformation07",
        component: () => import("@/views/info/ServiceInformation07.vue"),
        props: () => ({ type: 'info7' }),
      },
      {
        path: "/info/information8.do",
        name: "ServiceInformation08",
        component: () => import("@/views/info/ServiceInformation08.vue"),
        props: () => ({ type: 'info8' }),
      },
      {
        path: "/info/information9.do",
        name: "ServiceInformation09",
        component: () => import("@/views/info/ServiceInformation09.vue"),
        props: () => ({ type: 'info9' }),
      },
      {
        path: "/info/information10.do",
        name: "ServiceInformation10",
        component: () => import("@/views/info/ServiceInformation10.vue"),
        props: () => ({ type: 'info10' }),
      },
      {
        path: "info/commission.do",
        name: "InfoCommission",
        component: () => import("@/views/info/ServiceInfoCommission.vue"),
        props: () => ({ type: 'info10' }),
      },
      {
        path: "info/niceinfo.do",
        name: "InfoNiceinfo",
        component: () => import("@/views/info/ServiceInfoNiceinfo.vue"),
        props: () => ({ type: 'info10' }),
      },
      {
        path: "/info/document.do",
        name: "SubmitDocument",
        component: () => import("@/views/info/ServiceInfoDocument.vue"),
        props: () => ({ type: 'document' }),
      },
      {
        path: "/member/joinStep1.do",
        name: "JoinStep1",
        component: () => import("@/views/member/JoinStep1.vue"),
      },
      {
        path: "/member/joinStep2.do",
        name: "JoinStep2",
        component: () => import("@/views/member/JoinStep2.vue"),
      },
      {
        path: "/member/joinStep3.do",
        name: "JoinStep3",
        component: () => import("@/views/member/JoinStep3.vue"),
      },
      {
        path: "/mypage/pwcheck.do",
        name: "PasswordCheck",
        component: () => import("@/views/mypage/PasswordCheck.vue"),
        props: () => ({ type: 'userinfo' }),
        meta: { authRequired: true, types: [NORMAL_TYPE] },
      },
      {
        path: "/mypage/user.do",
        name: "mypageuser",
        component: () => import("@/views/mypage/MypageUserInfo.vue"),
        props: () => ({ type: 'userinfo' }),
        meta: { authRequired: true, types: [NORMAL_TYPE] },
      },
      {
        path: "/mypage/pwchange.do",
        name: "pwchange",
        component: () => import("@/views/mypage/PasswordChange.vue"),
        props: () => ({ type: 'pwchange' }),
        meta: { authRequired: true, types: [NORMAL_TYPE] },
      },
      {
        path: "/mypage/withdrawal.do",
        name: "withdrawal",
        component: () => import("@/views/mypage/UserWithdrawal.vue"),
        props: () => ({ type: 'withdrawal' }),
        meta: { authRequired: true, types: [NORMAL_TYPE] },
      },
      {
        path: "/note_list_v2.do",
        name: "NoteList",
        component: () => import("@/views/cs/NoteList.vue"),
        props: () => ({ type: 'note' }),
      },
      {
        path: "/note_newForm_v2.do",
        name: "NoteNewForm",
        component: () => import("@/views/cs/NoteForm.vue"),
        props: () => ({ type: 'note', mode: 'new' }),
        meta: { authRequired: true, types: [BOARD_ADMIN_TYPE] },
      },
      {
        path: "/note_modForm_v2.do",
        name: "NoteModForm",
        component: () => import("@/views/cs/NoteForm.vue"),
        props: (route) => ({ type: 'note', mode: 'mod', postId: route.query.postId }),
        meta: { authRequired: true, types: [BOARD_ADMIN_TYPE] },
      },
      {
        path: "/pds_list_v2.do",
        name: "PdsList",
        component: () => import("@/views/cs/PdsList.vue"),
        props: () => ({ type: 'pds' }),
      },
      {
        path: "/pds_newForm_v2.do",
        name: "PdsNewForm",
        component: () => import("@/views/cs/PdsForm.vue"),
        props: () => ({ type: 'pds', mode: 'new' }),
        meta: { authRequired: true, types: [BOARD_ADMIN_TYPE] },
      },
      {
        path: "/pds_modForm_v2.do",
        name: "PdsModForm",
        component: () => import("@/views/cs/PdsForm.vue"),
        props: (route) => ({ type: 'pds', mode: 'mod', postId: route.query.postId }),
        meta: { authRequired: true, types: [BOARD_ADMIN_TYPE] },
      },
      {
        path: "/cust/faq.do",
        name: "CustFaq",
        component: () => import("@/views/cs/CustFaq.vue"),
        props: () => ({ type: 'faq' }),
      },
      {
        path: "/cust/contact.do",
        name: "CustContact",
        component: () => import("@/views/cs/CustContact.vue"),
        props: () => ({ type: 'contact' }),
      },
      {
        path: "/main/findPw.do",
        name: "FindPw",
        component: () => import("@/views/FindPassword.vue"),
        props: () => ({ type: 'findPw' }),
      },
      {
        path: "/ra_newForm_v2.do",
        name: "AssessmentNew",
        component: () => import("@/views/assessment/AssessmentForm.vue"),
        props: (route) => ({ type: 'req', mode: 'new', newtype: route.query.newtype }),
        meta: { authRequired: true, types: [NORMAL_TYPE] },
      },
      {
        path: "/ra_modForm_v2.do",
        name: "AssessmentMod",
        component: () => import("@/views/assessment/AssessmentForm.vue"),
        props: (route) => ({ type: 'req', mode: 'mod', newtype: route.query.newtype }),
        meta: { authRequired: true, types: [NORMAL_TYPE] },
      },
      {
        path: "/ra_list_v2.do",
        name: "AssessmentList",
        component: () => import("@/views/assessment/AssessmentList.vue"),
        props: () => ({ type: 'list' }),
        meta: { authRequired: true, types: [NORMAL_TYPE] },
      },
      {
        path: "/ra_list_result_v2.do",
        name: "AssessmentResult",
        component: () => import("@/views/assessment/AssessmentResult.vue"),
        props: () => ({ type: 'result' }),
        meta: { authRequired: true, types: [NORMAL_TYPE] },
      },
      {
        path: "/fu_list_v2.do",
        name: "AssessmentFileUpload",
        component: () => import("@/views/assessment/AssessmentFileUpload.vue"),
        props: (route) => ({ type: 'list', sNo: route.query.s_no, rBzInsNo: route.query.bz_ins_no }),
        meta: { authRequired: true, types: [NORMAL_TYPE] },
      },
      {
        path: "/ra_viewPage_v2.do",
        name: "AssessmentInfo",
        component: () => import("@/views/assessment/AssessmentInfo.vue"),
        props: (route) => ({ type: 'list', sNo: route.query.s_no }),
        meta: { authRequired: true, types: [NORMAL_TYPE] },
      },
      {
        path: "/progress/agree.do",
        name: "progressAgree",
        component: () => import("@/views/assessment/AssessmentAgree.vue"),
        props: () => ({ type: 'list' }),
        meta: { authRequired: true, types: [NORMAL_TYPE] },
      },
      {
        path: "/rtr_newForm_v2.do",
        name: "AssessmentRtr",
        component: () => import("@/views/assessment/AssessmentRtrForm.vue"),
        props: (route) => ({ type: 'result', sNo: route.query.s_no }),
        meta: { authRequired: true, types: [NORMAL_TYPE] },
      },
    ],
  },
  //popup
  {
    path: '/progress/quotation.do',
    component: PopupLayout,
    children: [{
      path: '',
      component: () => import("@/views/popup/ProgressQuotation.vue"),
      props: route => ({ sNo: route.query.s_no })
    }],
  },
  {
    path: '/tax.do',
    component: PopupLayout,
    children: [{
      path: '',
      component: () => import("@/views/popup/InputTax.vue"),
      meta: { authRequired: true, types: [NORMAL_TYPE] },
    }],
  },
  {
    path: '/progress/agree_report.do',
    component: PopupLayout,
    children: [{
      path: '',
      component: () => import("@/views/popup/AgreeReport.vue"),
      props: (route) => ({ sNo: route.query.s_no }),
      meta: { authRequired: true, types: [NORMAL_TYPE] },
    }],
  },
  {
    path: "/credit_agree.do",
    component: PopupLayout,
    children: [{
      path: "/credit_agree.do",
      name: "CreditAgree",
      component: () => import("@/views/agree/CreditAgree.vue"),
      props: (route) => ({ sno: route.query.sno, bzno: route.query.bzno, seq: route.query.seq }),
    }],
  },
  {
    path: "/index_upload.do",
    component: PopupLayout,
    children: [{
      path: "/index_upload.do",
      name: "IndexUpload",
      component: () => import("@/views/IndexUpload.vue"),
    }],
  },
  {
    path: "/sendSitePop.do",
    component: PopupLayout,
    children: [{
      path: "/sendSitePop.do",
      name: "SendSitePop",
      component: () => import("@/views/SendSitePop.vue"),
      props: (route) => ({ siteNm: route.query.siteNm, searchSiteValue: route.query.searchSiteValue }),
    }],
  },
  {
    path: "/fu_list_external_v2.do",
    component: PopupLayout,
    children: [{
      path: "/fu_list_external_v2.do",
      name: "ExternalFileUpload",
      component: () => import("@/views/file/FileUpload.vue"),
    }],
  },
  {
    path: "/upload.do",
    component: PopupLayout,
    children: [{
      path: "/upload.do",
      name: "Upload",
      component: () => import("@/views/file/FileUpload.vue"),
    }],
  },
  {
    path: "/etc/csDownload.do",
    component: PopupLayout,
    children: [{
      path: "/etc/csDownload.do",
      name: "EtcCsDownload",
      component: () => import("@/views/file/FileCsDownload.vue"),
      props: (route) => ({ bzInsNo: route.query.bz_ins_no }),
    }],
  },
  {
    path: "/nice-pass/result",
    component: PopupLayout,
    children: [{
      path: "/nice-pass/result",
      name: "NicePassResult",
      component: () => import("@/views/NicePassResultPage.vue"),
    }],
  },
];

const router = createRouter({
  mode: "history",
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(routeInfo => routeInfo.meta.authRequired)) {
    const isLogin = store.getters["userStore/isLogin"];
    const userType = store.getters["userStore/getType"];

    if (!isLogin) {
      alert("로그인 후 사용하실 수 있습니다.");
      // 로그인 페이지로 이동 전에 원래 요청 URL 저장
      store.commit('userStore/SET_REDIRECT_URL', to.fullPath);
      next("/");
    } else {
      if (to.meta.types && to.meta.types.includes(userType)) {
        store.commit('userStore/CLEAR_REDIRECT_URL');
        next();
      } else {
        alert("접근할 수 없습니다.");
        next("/");
      }
    }
  } else {
    next();
  }
});

export default router;
